<template>
  <v-col class="pa-0">
    <div v-if="!creatingUser" class="pa-6">
      <v-row>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-text-field
              class="input"
              label="Search..."
              prepend-inner-icon="mdi-magnify"
              rounded
              v-model="search"
              style="max-width: 300px"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              style="max-width: 300px"
              class="input"
              label="Selected User Type"
              rounded
              v-model="userType"
              :items="userTypes"
              @change="
                updateSelectedType();
                getUsers();
              "
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row
            v-if="userType != 'Admin' && storeUser.userType == 'Admin'"
            class="ma-0"
            justify="center"
            justify-md="start"
          >
            <v-select
              @change="setLastStatus"
              class="statusSelect input"
              style="max-width: 300px"
              label="Selected Status"
              rounded
              v-model="selectedStatus"
              :items="statusOptions"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="pa-6">
          <v-row
            v-if="storeUser"
            justify="center"
            justify-md="end"
            class="ma-0"
          >
            <v-btn
              v-if="
                (storeUser.userType == 'Admin' &&
                  storeUser.adminType == 'Super Admin') ||
                storeUser.userType == 'Company'
              "
              @click="
                selectedUser = null;
                creatingUser = true;
              "
              color="#e022d1"
              dark
              rounded
              width="auto"
              class="pink-btn"
              >{{ buttonText }}</v-btn
            >
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          no-data-text="No users yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredUsers"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedUser = item;
                  creatingUser = true;
                "
                >mdi-pencil</v-icon
              >
            </td>
          </template>
          <template v-slot:item.online="{ item }">
            <td>
              <v-icon style="font-size: 50px" color="green" v-if="item.online"
                >mdi-circle-small</v-icon
              >
              <v-icon style="font-size: 50px" color="red" v-if="!item.online"
                >mdi-circle-small</v-icon
              >
            </td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              class="capatilize"
              :color="statusColor(item.status || 'pending')"
              dark
              >{{ item.status || "pending" }}</v-chip
            >
          </template>
        </v-data-table>
      </v-row>
      <v-row justify="center" justify-md="start" class="ma-0">
        <v-col cols="12" md="3">
          <v-row justify="center" justify-md="start">
            <VueJsonToCsv
              :json-data="exportData"
              :csv-title="'Users'"
              class="export-btn mt-6"
            ></VueJsonToCsv>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div v-if="creatingUser" class="pa-4">
      <HandleUser
        :userType="userType"
        :user="selectedUser"
        :companies="companies"
        :doctors="doctors"
        @userCreated="creatingUser = false"
        @update="getUsers()"
      />
    </div>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular
          :size="100"
          color="#4390c0"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import HandleUser from "../components/HandleUser.vue";

import VueJsonToCsv from "vue-json-to-csv";

import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [],
      creatingUser: false,
      userType: "Doctor",
      userTypes: [],
      users: [],
      search: "",
      selectedUser: null,
      loading: false,
      companies: [],
      doctors: [],
      selectedStatus: "approved",
      statusOptions: [
        { text: "Pending", value: "pending" },
        { text: "On Hold", value: "on hold" },
        { text: "Approved", value: "approved" },
        { text: "Denied", value: "denied" },
        { text: "Email Unverified", value: "Email Unverified" },
      ],
      unsubscribeUsers: null,
      unsubscribeCompanies: null,
    };
  },
  components: {
    HandleUser,
    VueJsonToCsv,
  },
  async mounted() {
    setTimeout(async () => {
      if (localStorage.getItem("lastViewedUserType")) {
        this.userType = localStorage.getItem("lastViewedUserType");
      }

      let res = await this.getUsers();
      let res2 = await this.getCompanies();
      let res3 = await this.getDoctors();

      if (localStorage.getItem("LastViewedStatusType")) {
        this.selectedStatus = localStorage.getItem("LastViewedStatusType");
      }

      if (localStorage.getItem("ViewedUser")) {
        let selectedUser = JSON.parse(localStorage.getItem("ViewedUser"));

        let newUser = this.users.find((user) => user.id == selectedUser.id);

        if (newUser) {
          this.selectedUser = newUser;
          this.userType = this.selectedUser.userType;
          this.creatingUser = true;
        }
      }

      if (this.storeUser.userType == "Admin") {
        this.userTypes = ["Admin", "Doctor", "Company"];
      } else if (this.storeUser.userType == "Doctor") {
        this.userTypes = ["Doctor"];
      } else if (this.storeUser.userType == "Company") {
        this.userTypes = ["Doctor", "Company"];
      }
    }, 1000);
  },
  methods: {
    setLastStatus() {
      localStorage.setItem("LastViewedStatusType", this.selectedStatus);
    },
    updateSelectedType() {
      localStorage.setItem("lastViewedUserType", this.userType);
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#DC143C";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        case "on hold":
          return "grey";
        default:
          return "grey";
      }
    },
    setHeaders() {
      if (this.userType == "Company") {
        this.headers = [
          {
            text: "Company Name",
            value: "companyName",
          },
          { text: "Practice Number", value: "practiceNumber" },
          { text: "Email Address", value: "email" },
          { text: "Cell Number", value: "CellNo" },
          { text: "Address", value: "address.placeName" },
          { text: "Status", value: "status" },
          { text: "Action", value: "action" },
        ];
      } else if (this.userType == "Doctor") {
        this.headers = [
          {
            text: "First Name",
            value: "name",
          },
          { text: "Surname", value: "surname" },
          { text: "ID No.", value: "idNumber" },
          { text: "Email Address", value: "email" },
          { text: "Cell Number", value: "CellNo" },
          { text: "Status", value: "status" },
          { text: "Online", value: "online" },
          { text: "Action", value: "action" },
        ];
      } else {
        this.headers = [
          {
            text: "First Name",
            value: "name",
          },
          { text: "Surname", value: "surname" },
          { text: "ID No.", value: "idNumber" },
          { text: "Email Address", value: "email" },
          { text: "Cell Number", value: "CellNo" },
          { text: "Admin Type", value: "adminType" },
          { text: "Action", value: "action" },
        ];
      }
    },
    getUsers() {
      if (this.unsubscribeUsers) {
        this.unsubscribeUsers();
      }

      if (this.unsubscribeCompanies) {
        this.unsubscribeCompanies();
      }

      if (this.unsubscribeDoctors) {
        this.unsubscribeDoctors();
      }

      this.setHeaders();

      try {
        let q;

        if (this.userType === "Admin") {
          q = query(collection(db, "dashboardUsers"));
        } else if (this.userType === "Doctor") {
          q = query(collection(db, "doctors"));
        } else if (this.userType === "Company") {
          q = query(collection(db, "businesses"));
        }

        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeUsers = onSnapshot(q, (querySnapshot) => {
          this.users = [];

          querySnapshot.forEach((doc) => {
            let tempUser = doc.data();
            tempUser.id = doc.id;

            if (
              tempUser.userType === "Doctor" &&
              tempUser.lastOnline?.seconds
            ) {
              const lastActiveMs = tempUser.lastOnline.seconds * 1000;
              const nowMs = Date.now();

              tempUser.online = Math.abs(nowMs - lastActiveMs) <= 5 * 60 * 1000;
            } else {
              tempUser.online = false;
            }

            // Original filtering logic
            if (this.storeUser.userType === "Admin") {
              this.users.push(tempUser);
            } else if (
              this.storeUser.userType === "Doctor" &&
              tempUser.id === this.storeUser.id
            ) {
              this.users.push(tempUser);
            } else if (
              this.storeUser.userType === "Company" &&
              (tempUser.email === this.storeUser.email ||
                tempUser.businessID === this.storeUser.id)
            ) {
              this.users.push(tempUser);
            }

            // Extra safety: include user if businessID or id matches storeUser
            if (
              tempUser.businessID === this.storeUser.id ||
              tempUser.id === this.storeUser.id
            ) {
              if (!this.users.includes(tempUser)) {
                this.users.push(tempUser);
              }
            }
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    getCompanies() {
      try {
        const q = query(collection(db, "businesses"));

        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeCompanies = onSnapshot(q, (querySnapshot) => {
          this.companies = [];

          querySnapshot.forEach((doc) => {
            let tempCompany = doc.data();
            tempCompany.id = doc.id;

            this.companies.push(tempCompany);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    getDoctors() {
      try {
        const q = query(collection(db, "doctors"));

        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeDoctors = onSnapshot(q, (querySnapshot) => {
          this.doctors = [];

          querySnapshot.forEach((doc) => {
            let tempDoctor = doc.data();
            tempDoctor.id = doc.id;

            this.doctors.push(tempDoctor);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
  },
  computed: {
    filteredUsers() {
      return this.users.filter((item) => {
        const matchesStatus =
          this.selectedStatus === "Email Unverified"
            ? item.emailVerified !== true
            : !this.selectedStatus || item.status === this.selectedStatus;

        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        if (this.userType == "Admin") {
          return matchesSearch;
        } else if (this.storeUser.userType == "Admin") {
          return matchesStatus && matchesSearch;
        } else {
          return matchesSearch;
        }
      });
    },
    storeUser() {
      return this.$store.state.user || {};
    },
    exportData() {
      let objectList = [];
      let tempObject = {};

      if (this.filteredUsers) {
        this.filteredUsers.forEach((event) => {
          tempObject = {};

          if (this.userType == "Company") {
            tempObject.CompanyName = event.companyName;
            tempObject.PracticeNumber = event.practiceNumber;
            tempObject.City = event.city;
            tempObject.Province = event.province;
            tempObject.PostalCode = event.postalCode;
          } else if (this.userType == "Doctor") {
            tempObject.Name = event.name;
            tempObject.Surname = event.surname;
            tempObject.Profession = event.profession;
            tempObject.ClientPreference = event.clientPreference;
            tempObject.IDNumber = event.idNumber;
          } else {
            tempObject.Name = event.name;
            tempObject.Surname = event.surname;
            tempObject.IDNumber = event.idNumber;
          }

          tempObject.Email = event.email;
          tempObject.PhoneNumber = event.CellNo;
          tempObject.Address = event.address;

          objectList.push(tempObject);
        });

        return objectList;
      } else {
        return [{}];
      }
    },
    buttonText() {
      if (this.storeUser.userType == "Admin") {
        return "Add User";
      } else if (this.storeUser.userType == "Company") {
        return "Add Doctor";
      }
    },
  },
  beforeUnmount() {
    if (this.unsubscribeUsers) {
      this.unsubscribeUsers();
    }

    if (this.unsubscribeCompanies) {
      this.unsubscribeCompanies();
    }

    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }
  },
};
</script>

<style scoped></style>
